
/**
 * InfiniteScroll
 */

class InfiniteScroll {

	private isCreated: boolean;

	private isLoadingFlag: boolean;

	private isUpStop: boolean;

	private isDownStop: boolean;

	private direction: string;

	private offset: number;

	private callback: any;

	private currScrollTop: any;

	private $target: any;

	constructor( callback: any, $target?: any ) {
		this.isCreated = false;
		this.isLoadingFlag = false;
		this.isUpStop = false;
		this.isDownStop = false;
		this.direction = 'down';
		this.offset = 1;
		this.callback = callback;
		this.currScrollTop = this.offset;
		this.$target = $target;
	}

	public isLoading() {
		return this.isLoadingFlag;
	}

	public setIsLoadingFlag( bool: boolean ) {
		this.isLoadingFlag = bool;
	}

	public loadedEnd() {
		this.isLoadingFlag = false;
		jQuery( window ).scrollTop( this.currScrollTop );
	}

	public stop( dir: string ) {
		if ( dir === 'up' ) {
			this.isUpStop = true;
		} else {
			this.isDownStop = true;
		}
	}

	public start() {
		if ( !this.isCreated ) {
			this.isCreated = true;

			jQuery( window ).scroll( () => {
				if ( this.isLoadingFlag ) {
					return;
				}

				if ( jQuery( window ).scrollTop() === 0 ) {
					if ( this.isUpStop ) {
						return;
					}

					this.isLoadingFlag = true;
					this.direction = 'up';
					this.currScrollTop = jQuery( window ).height();

					if ( this.callback ) {
						this.callback( this.direction );
					}

				} else if ( ( jQuery( document ).height() - jQuery( window ).height() ) <= $( window ).scrollTop() + this.offset ) {

					if ( this.isDownStop ) {
						return;
					}

					this.isLoadingFlag = true;
					this.direction = 'down';
					this.currScrollTop = jQuery( window ).scrollTop();

					if ( this.callback ) {
						this.callback( this.direction );
					}
				}
			});
			this.setInitPos();
		}
	}

	private setInitPos() {
		this.currScrollTop = jQuery( window ).scrollTop() || this.offset;
		jQuery( window ).scrollTop( this.currScrollTop );
	}
}

export default InfiniteScroll;
